module.exports = __webpack_public_path__ + "static/media/posto-image.3eaad404.png";